import { useEffect, useState } from "react";
import { TIMEOUT_TIME, SSO } from '../constants/general'
import { decodeStorage, encodeStorage, removeStorage } from "newFunctions/storageBase64";

export default function useTokenNew( props = false ) {
    const {
        timeRef = 100,
        name
    } = props

    const [ access_token, setAccess_token ] = useState( decodeStorage('access_token') )
    const [ isValid, setIsValid ] = useState( false )
    const [ checkValid, setCheckValid ] = useState( false )
    const [ revalidate, setRevalidate ] = useState( false )
    const [ updatedToken, setUpdatedToken ] = useState( false )

    useEffect(()=>{
        if(name){
            // console.log('nombreHookToken: ',name)
        }
    },[])
     
    const updateToken = async () => {
        setUpdatedToken(true)
        window.localStorage.setItem( 'udToken','pending' )
        const RefToken  = decodeStorage('refresh_token')

        let apiURL, rawSSO
        apiURL = `https://login.sears.com.mx/auth/realms/${SSO.realmSSO}/protocol/openid-connect/token`
        rawSSO = `refresh_token=${RefToken}&client_id=${SSO.clientSSO}&grant_type=refresh_token&redirect_uri=${encodeURIComponent(`https://www.sears.com.mx/authenticated`)}`
        // apiURL = `${SSO.ssoURL}/auth/realms/${SSO.realmSSO}/protocol/openid-connect/token`
        // rawSSO = `refresh_token=${RefToken}&client_id=${SSO.clientSSO}&grant_type=refresh_token&redirect_uri=${encodeURIComponent(`${window.location.origin}/authenticated`)}`
        
        try {
            const config = {
                method: 'POST',
                withCredentials: true,
                timeout: 25,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: rawSSO
            };
            const response = await fetch(apiURL, config)
            const data = await response.json();
            if(response?.status === 200){
                encodeStorage('access_token', data?.access_token)
                encodeStorage('refresh_token', data?.refresh_token)
                encodeStorage('session_token', data?.access_token)
                setAccess_token(data?.access_token)
                setUpdatedToken(false)
                window.localStorage.removeItem( 'udToken' )
                return data
            }else if(response?.status === 400){
                removeStorage('access_token')
                removeStorage('refresh_token')
                removeStorage('session_token')
                setUpdatedToken(false)
                window.localStorage.removeItem( 'udToken' )
            }
        } catch (error) {
            setUpdatedToken(false)
            window.localStorage.removeItem( 'udToken' )
            console.error('Error fetching getEventTable data:', error);
        }
    } 

    const forceToken = () => {
        console.log('se activo el forceToken')
        updateToken()
    }

    useEffect(()=>{
        if(access_token){
            let lsToken = decodeStorage('access_token')

            const token = lsToken?.split('.').length  === 3 ?  JSON.parse( atob( lsToken?.split('.')[1] ) ) : lsToken?.split('.').length  === 2 ? 'error' : null
            const timeExp = token?.exp ? (token?.exp * 1000) - 180000  : null
            const timeNow = Math.floor(Date.now())
            
            // console.log('timeExp: ',  new Date( timeExp ) )
            // console.log('timeNow: ', new Date( timeNow ) )
            
            if(timeNow > timeExp){
                setIsValid(false)
                // console.log('valio pero ya lo actualizamos... no temas :S')
                if(!updatedToken){
                    if(localStorage.getItem('udToken') !== 'pending'){
                        updateToken()
                        // console.log('update... ', name)
                    }else{
                        setCheckValid(true)
                        // console.log('pending... ', name)
                    }
                }
            }else{
                // console.log('todavia estamos chidos :P ', name)
                setIsValid(true)
            }
        }
    },[ access_token, revalidate ])


    useEffect(()=>{
        if(checkValid){
            setTimeout(() => {
                setCheckValid(false)
                setRevalidate(true)
                // console.log('revalidate... ', name)
            },1000)
        }
    },[ checkValid ])

    return {
        access_token,
        forceToken,
        isValid
    };
}